export type AreaSelection = AreaTools | null

export enum AreaTools {
  POINT = 'POINT',
  POINT2 = 'POINT2',
  POINT3 = 'POINT3',
  POINT_PONDERA = 'POINT_PONDERA',
  POLYGON = 'POLYGON',
  REGION = 'REGION',
  FILE_UPLOAD = 'FILE_UPLOAD',
  RADIUS = 'RADIUS',
  MEASURE = 'MEASURE',
  TRAFFIC_TOOL = 'TRAFFIC_TOOL',
  MOBILITY_REPORT_TOOL = 'MOBILITY_REPORT_TOOL',
  PREDICTIVE_REPORT_TOOL = 'PREDICTIVE_REPORT_TOOL',
  CUSTOM_REPORT_TOOL = 'CUSTOM_REPORT_TOOL',
  KEYWORDS_REPORT_TOOL = 'KEYWORDS_REPORT_TOOL',
}

export enum EditorModes {
  SELECT = 'SELECT',
  READ_ONLY = 'READ_ONLY',
  EDITING = 'EDITING',
  DRAW_POINT = 'DRAW_POINT',
  DRAW_PATH = 'DRAW_PATH',
  DRAW_POLYGON = 'DRAW_POLYGON',
  DRAW_RECTANGLE = 'DRAW_RECTANGLE',
  DRAW_CIRCLE = 'DRAW_CIRCLE',
}
